import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { resetTenantOnboardingSkip } from './services';
import { COMMON_QUERY_KEY } from './keys';
import { IBaseApiResponse, ICommonError } from 'types/common';

export const useResetTenantOnboardingSkipMutation = (
  options?: UseMutationOptions<IBaseApiResponse, AxiosError<ICommonError>>,
) =>
  useMutation<IBaseApiResponse, AxiosError<ICommonError>>({
    mutationFn: resetTenantOnboardingSkip,
    mutationKey: [COMMON_QUERY_KEY.RESET_TENANT_ONBOARDING_SKIP],
    retry: false,
    ...options,
  });
